import React from 'react';
import { DefaultButton, IButtonStyles } from '@fluentui/react';

const styles : IButtonStyles = {
    root: {
        backgroundColor: 'transparent',
        color: 'var(--color-primario)',
        borderColor: 'var(--color-primario)',
        borderLeftWidth: 0,
        borderRightWidth: 0,
        borderTopWidth: 0,
        borderBottomWidth: 1,
        paddingTop: 25,
        paddingBottom: 25,
        paddingLeft: 10,
        paddingRight: 10,
    },
    rootHovered: {
        backgroundColor: 'var(--color-primario)',
        color: 'white',
    },
    label: {
        fontWeight: 500,
        textAlign: 'left',
    },
};

interface IButtonLinkComponentProps {
    text?: string;
    onClick?: (event: any) => void;
    icon?: string;
    disabled?: boolean;
    className?: string;
};

const ButtonLinkComponent = (props: IButtonLinkComponentProps) => {
    return (
        <DefaultButton
            text={props.text}
            onClick={props.onClick}
            iconProps={props.icon ? {
                iconName: props.icon,
            } : {}}
            styles={styles}
            disabled={props.disabled}
            className={props.className} />
    );
};

export default ButtonLinkComponent;
